import React, { createRef, PureComponent } from 'react'
import { Avatar, Button, Col, Divider, Icon, Popover, Row, Table } from 'antd'
import clsx from 'clsx'
import lodash, { find, isEmpty } from 'lodash'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'

import UpdateReceivedQuantity from './../UpdateReceivedQuantityContainer'
import { currentFormatter } from './../../../Common/services/format'
import { getVar } from './../../../../system/support/helpers'

import Logs from './Logs'
import { CHECKING_STATUSES } from '../../constants'
import PictureWall from '../../UploadProductDamagedImages/PictureWall'
import { ProductImage } from '../../../Common/components/ProductImage'

class ProductInfo extends PureComponent {
    state = {
        updateReceivedQuantityInputRef: createRef(),
    }

    focusReceivedQuantityInput = () => {
        const { updateReceivedQuantityInputRef } = this.state

        updateReceivedQuantityInputRef.current && updateReceivedQuantityInputRef.current.focus()
    }

    componentDidUpdate(prevProps) {
        const { focus } = this.props

        if (focus && !prevProps.focus) {
            this.focusReceivedQuantityInput()
        }
    }

    componentDidMount() {
        const { focus } = this.props

        if (focus) {
            this.focusReceivedQuantityInput()
        }
    }

    render() {
        const { updateReceivedQuantityInputRef } = this.state
        const { t, product = {}, successUpdateReceivedQuantitiesCount, updatingReceivedQuantity, onReceiveAll, handleReportIssue, productErrors } = this.props
        const statusChecking = getVar(this.props, 'package.package_detail.status_checking')
        const packageItems = find(this.props.packageItems, ['package_item.code_item', product.code_item])
        const packageItemIssues = getVar(find(this.props.packageItems, ['package_item.code_item', product.code_item]), 'package_item_issues', [])
        return (
            <Row
                gutter={32}
                type={'flex'}
                className={'a-block-info a-item-package m-0 amb-16 gflex-direction-column'}>
                <div className="a-item-package__top">
                    <Col
                        lg={{ span: 12 }}
                        xl={{ span: 7 }}
                        xxl={{ span: 8 }}
                        className="pl-0">
                        <div className="gflex">
                            <div className="a-item-package-checking__avatar">
                                <Popover
                                    title={product.original_name}
                                    trigger="hover"
                                    placement="right"
                                    content={
                                        <img
                                            referrerPolicy={'no-referrer'}
                                            src={product.product_image}
                                            alt="Product image"
                                        />
                                    }>
                                    <div>
                                        <ProductImage imageUrl={product.product_image} size={140} />
                                    </div>
                                </Popover>

                                <span>{product.code_item}</span>
                            </div>
                            <div className="a-item-package__info">
                                <a
                                    className="a-item-package--link"
                                    href={product.url}
                                    rel="noopener noreferrer"
                                    target="_blank">
                                    {product.original_name}
                                </a>
                                <span>{lodash.map(product.variant_properties || [], 'originalValue').join(' / ') || '--'}</span>
                            </div>
                        </div>
                    </Col>
                    <Col
                        lg={{ span: 6 }}
                        xl={{ span: 5 }}
                        xxl={{ span: 3 }}
                        className="info--group amb-14">
                        <label className="info--label a-text--nowrap">{t('package:checking.unit_price')} (VND)</label>
                        <p className="a-text--fz-18 a-text--bold mb-0 mt-2 item-package__info-unit_price">
                            {currentFormatter.toLocaleStringCurrency(getVar(product, 'unit_price', 0))}
                        </p>
                    </Col>
                    <Col
                        lg={{ span: 6 }}
                        xl={{ span: 3 }}
                        xxl={{ span: 3 }}
                        className="info--group amb-14">
                        <label className="info--label a-text--nowrap">{t('package:checking.purchased_quantity')}</label>
                        <p className="a-text--fz-18 a-text--bold mb-0 mt-2 item-package__info-purchased_quantity">
                            {getVar(product, 'purchase_quantity', '--')}
                        </p>
                    </Col>
                    <Col
                        lg={{ span: 6 }}
                        xl={{ span: 4 }}
                        xxl={{ span: 3 }}
                        className="info--group amb-14 pr-0">
                        <label className="info--label">{t('package:checking.order_over_package_received_quantity')}</label>
                        <p className="a-text--fz-18 a-text--bold mb-0 mt-2 item-package__info-package_received_quantity">
                            <span
                                className={clsx('item-package__info-order_received_quantity', {
                                    'a-text--red': getVar(product, 'order_received_quantity', 0) > getVar(product, 'purchase_quantity', 0),
                                })}>
                                {getVar(product, 'order_received_quantity', '--')}
                            </span>
                            /{getVar(product, 'package_received_quantity', '--')}
                        </p>
                    </Col>
                    <Col
                        lg={{ span: 8 }}
                        xl={{ span: 5 }}
                        xxl={{ span: 3 }}
                        className="info--group mb-0 pr-0">
                        <label className="info--label">{t('package:checking.package_quantity')}</label>
                        <UpdateReceivedQuantity
                            packageId={this.props.packageId}
                            product={this.props.product}
                            reupdateQuantity={successUpdateReceivedQuantitiesCount}
                            inputRef={updateReceivedQuantityInputRef}
                            loading={updatingReceivedQuantity}
                            onSubmit={onReceiveAll}
                        />
                    </Col>

                    {!isEmpty(packageItems) && statusChecking === CHECKING_STATUSES.CHECKING && (
                        <Col
                            lg={{ span: 8 }}
                            xl={{ span: 5 }}
                            xxl={{ span: 3 }}
                            className="info--group mb-0 pr-0">
                            <label className="info--label mb-2">{'Đánh dấu sai/lỗi'}</label>
                            {!isEmpty(find(productErrors, ['id', getVar(packageItems, 'package_item.id')])) ? (
                                <Button
                                    onClick={() => handleReportIssue({ id: getVar(packageItems, 'package_item.id') }, true)}
                                    icon={'undo'}>
                                    {t('package:package_issue.action.unmark_as_defective')}
                                </Button>
                            ) : (
                                <Button
                                    onClick={() =>
                                        handleReportIssue({
                                            id: getVar(packageItems, 'package_item.id'),
                                            quantity: 0,
                                            received_quantity: getVar(product, 'order_received_quantityx', 0),
                                            purchase_quantity: getVar(product, 'package_received_quantity', 0),
                                            id_package_item: getVar(packageItems, 'package_item.id'),
                                            issue_type: '',
                                            description: '',
                                            name: product.original_name,
                                            url: product.url,
                                            image: product.product_image,
                                        })
                                    }
                                    icon={'exclamation-circle'}>
                                    {t('package:package_issue.action.mark_as_defective')}
                                </Button>
                            )}
                        </Col>
                    )}
                </div>
                {statusChecking === CHECKING_STATUSES.CHECKED && packageItemIssues.length > 0 && (
                    <Table
                        rowKey={record => record.id}
                        className={'amb-16'}
                        title={() => t('package:package_issue.title')}
                        dataSource={packageItemIssues}
                        columns={[
                            {
                                title: t('package:package_issue.label.damage_reason'),
                                dataIndex: 'issue_type',
                                key: 'issue_type',
                                render: text => {
                                    return getVar(find(this.props.packageDamagedReasons, ['code', text]), 'name', text)
                                },
                            },
                            {
                                title: t('package:package_issue.label.quantity'),
                                dataIndex: 'quantity',
                                key: 'quantity',
                            },
                            {
                                title: t('package:package_issue.label.description'),
                                dataIndex: 'description',
                                key: 'description',
                                width: '300px',
                            },
                            {
                                title: t('package:package_issue.label.images'),
                                dataIndex: 'image_urls',
                                key: 'image_urls',
                                render: (text, record) => {
                                    return (
                                        <>
                                            <Button
                                                className="a-btn a-btn--link a-btn--h-25 aradius--2 p-0 _btn-scan-upload-damaged-images-link"
                                                type="link"
                                                onClick={() =>
                                                    this.props.handleOpenModal({
                                                        package_id: this.props.packageId,
                                                        id_package_item: getVar(packageItems, 'package_item.id'),
                                                        id_package_item_issue: record.id,
                                                    })
                                                }>
                                                {t('package:get_qr_code_to_upload_images_from_cellphone')}
                                            </Button>
                                            <PictureWall
                                                productIssueInfo={record}
                                                sorted
                                            />
                                        </>
                                    )
                                },
                            },
                        ]}
                        pagination={false}
                    />
                )}
                <div className="a-item-package__bottom gflex">
                    <Col
                        className="info--group pl-0 mb-0 border-right"
                        lg={{ span: 10 }}>
                        <Logs logs={getVar(product, 'logs', [])} />
                    </Col>
                    <Col
                        className="info--group pr-0 mb-0"
                        lg={{ span: 14 }}>
                        <Row>
                            <Col className="info--group">
                                <label className="info--label">{t('package:checking.customer_note')}:</label>
                                <span className="info--value--small item-package__info-customer_note">{getVar(product, 'customer_note', '--')}</span>
                            </Col>
                            <Col className="info--group mb-0">
                                <label className="info--label">{t('package:checking.staff_note')}:</label>
                                <span className="info--value--small item-package__info-staff_note">{getVar(product, 'staff_note', '--')}</span>
                            </Col>
                        </Row>
                    </Col>
                </div>
            </Row>
        )
    }
}

ProductInfo.defaultProps = {
    packageId: null,
    product: {},
}

ProductInfo.propTypes = {
    packageId: PropTypes.number,
    product: PropTypes.object,
}

export default withTranslation()(ProductInfo)
